export enum InputTypes {
    TEXT = "text",
    SELECT = "select",
    RADIO = "radio"
}